import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import Form from 'react-bootstrap/Form';

type GasLimitFormProps = {
    group: string,
    updateGasLimit: Dispatch<SetStateAction<string>>
}

const GasLimitForm = ({ group, updateGasLimit }: GasLimitFormProps) => {
    const [estimateGas, setEstimateGas] = useState(true)
    const [gasLimit, setGasLimit] = useState('3000000')

    useEffect(() => {
        const limit = estimateGas ? '0' : gasLimit

        updateGasLimit(limit)
    }, [estimateGas, gasLimit])
    
    return (
        <Form className='gas-form-container'>
            <Form.Group>
                <Form.Label>Gas Limit</Form.Label>
                <Form.Check
                    type='radio'
                    id='default-radio'
                    label='Estimated Gas'
                    name={group}
                    defaultChecked
                    onClick={() => setEstimateGas(true)}
                />
                <Form.Check
                    id='disabled-default-radio'
                    children={
                        <div className='gas-form-control'>
                            <Form.Check.Input
                                type='radio'
                                name={group}
                                onClick={() => setEstimateGas(false)}
                            />
                            <Form.Check.Label>Custom</Form.Check.Label>
                            <Form.Control size='sm' type='number' defaultValue={3000000} min={0} onChange={(e) => setGasLimit(e.target.value)} />
                        </div>
                    }
                />
            </Form.Group>
        </Form>
    )
}

export default GasLimitForm